import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@fontsource/bebas-neue/400.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "sonner";
import { TopBar } from "@/components/site/TopBar";
import { Footer, MobileCallBar } from "@/components/site/Footer";
import { scrollToId } from "@/components/site/data";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import CityPage from "@/pages/CityPage";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.slice(1)), 150);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <BrowserRouter>
    <div className="grain overflow-x-clip bg-[#0D0D0B]">
      <ScrollManager />
      <TopBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/junk-removal/:slug" element={<CityPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <MobileCallBar />
      <Toaster position="top-center" richColors />
    </div>
    </BrowserRouter>
  );
}

export default App;
